import { createApiEffect } from '@/features/api/common/create-api-effect'
import { AdmissionStatusType } from '@/features/api/student/types'

export const getStatusesListFx = createApiEffect<void, AdmissionStatusType[]>({
  requestMapper: () => ({
    method: 'GET',
    url: '/api/ticket-app/admission-status/list/',
  }),
})
